// extracted by mini-css-extract-plugin
export default {"MainContainer":"Login_MainContainer__cfxZI","Form":"Login_Form__CYn+T","SubmitButton":"Login_SubmitButton__4Mql-"};